import { render, staticRenderFns } from "./DiscardChangesModal.vue?vue&type=template&id=6fb34e7d&"
import script from "./DiscardChangesModal.vue?vue&type=script&lang=js&"
export * from "./DiscardChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscardChangesModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports